module.exports = __webpack_public_path__ + "static/CruzBlanca-960a304303ee594aa46792b9a0cfde58.svg";